
import styled, { css } from 'styled-components';
import { useGetEventsHappeningAtQuery } from '../../../api/event.api';
import moment from 'moment';
import LoadingSpinner from '../../common/LoadingSpinner';
import axios from 'axios';
import { UIStoreNS } from '../../../stores/useUIStore';
import Button from '../../common/Button';

const BookingSelectionStyled = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding-bottom: 16px;
  gap: 12px;
`;

const BookingOption = styled.div<{ isDisabled?: boolean }>`
  background: #f0f3f5;
  border-radius: var(--radius);
  padding: 24px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 24px;
  width: 100%;

  > div.info {
    flex: 1;
  }

  > button {
    flex: 0 0 180px;
  }

  h1 {
    font-family: Playfair Display, serif;
    font-size: 24px;
    color: #12131a;
    margin: 0 0 8px;
  }

  p {
    margin: 0;
    line-height: 24px;
    font-size: 14px;

    span {
      color: #7d8f9b;
    }
  }

  ${props => props.isDisabled && css`
    cursor: not-allowed !important;
    opacity: 0.65;
  `};
  
  @media screen and (max-width: 768px) {
    padding: 16px;
    
    h1 {
      font-size: 20px;
    }
    
    p {
      font-size: 13px;
    }
  }
`;

const BookingSelection = ({
  restaurantId,
  date,
  isTableAvailable,
  callback,
}: Omit<UIStoreNS.BookingSelectionPayload, 'type'>) => {
  const momentDate = moment(date);
  const cancelToken = axios.CancelToken.source();

  const { data, isLoading } = useGetEventsHappeningAtQuery(
    restaurantId,
    momentDate.format(moment.defaultFormatUtc),
    cancelToken,
  );

  const dateTime = momentDate.format('DD. MMMM HH:mm');

  return (
    <BookingSelectionStyled>
      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <>
          <BookingOption isDisabled={!isTableAvailable}>
            <div className={'info'}>
              <h1>À la carte</h1>
              <p>
                Make a table reservation for our traditional à la carte menu
                <br />
                <span>{dateTime}</span>
              </p>
            </div>
            <Button disabled={!isTableAvailable} onClick={() => callback('table')}>Reserve</Button>
          </BookingOption>
          {data &&
            Array.isArray(data) &&
            data!.map((ev) => (
              <BookingOption key={ev.id}>
                <div className={'info'}>
                  <h1>{ev.name}</h1>
                  <p>
                    {ev.shortDescription}
                    <br />
                    <span>{dateTime} - Additional fees may apply</span>
                  </p>
                </div>
                <Button onClick={() => callback('event', ev)}>Reserve</Button>
              </BookingOption>
            ))}
        </>
      )}
    </BookingSelectionStyled>
  );
};

export default BookingSelection;
